<template>
  <div class="authority-setting">
      <headerNotice routerName="权限设置"></headerNotice>
      <div class=btn-wrapper>
        <el-button @click='back'>返 回</el-button>
        <el-button type='primary' @click='updateDivisionAccess'>提 交</el-button>
      </div>
    <div class="content" v-loading="loading">
      <h1>当前角色: {{divisionName}}</h1>
      <!-- 多选列表 -->
      <div class="multipleBox" v-for="(item1, index1) in accessList" :key="index1">
        <p style="padding: 10px; border: 1px solid #e5e4e5;">
          <el-checkbox
            border
            v-model="item1.access"
            :true-label='1'
            :false-label='0'
            style="width: 166px;"
            @change='changeRowLists(index1,$event)'
          >{{item1.cloName}}</el-checkbox>
        </p>
        <div
          v-for="(item2, index2) in item1.rowLists"
          :key="index2"  
          class="second"
        >
          <p style="padding: 10px; border: 1px solid #e5e4e5; border-top: none;">
            <el-checkbox v-model="item2.access" :true-label='1' :false-label='0' @change='changeColLists(index1, index2, $event)' style="width: 166px;" border>{{item2.rowName}}</el-checkbox>
          </p>
          <p  class="third" style="padding: 10px; border: 1px solid #e5e4e5; border-top: none;">
            <span style="margin-right: 10px;" v-for="(item3, index3) in item2.childMenu" :key='index3'>
              <el-checkbox @change='changeColListsChild(index1, index2, index3, $event)' :true-label='1' :false-label='0' v-model="item3.access" style="width: 166px;" border>{{item3.name}}</el-checkbox>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  components: {
    headerNotice
  },
  props: {},
  data() {
    return {
      loading: false,
      divisionID: "",
      divisionName: "",
      accessList: [],
      accessTreeKeys: [],
      defaultProps: {
        children: "childMenu",
        value: "access",
        label: "name"
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    changeRowLists(idx,e) {
      let target = this.accessList[idx]
      target.access = e;
      if(target.rowLists.length) {
        for(let i = 0; i < target.rowLists.length; i++) {
          target.rowLists[i].access = e
          if(target.rowLists[i].childMenu.length){
            for(let j = 0; j < target.rowLists[i].childMenu.length; j++)  {
               target.rowLists[i].childMenu[j].access = e
            }
          } 
        }
      }
    },
    changeColLists(idx1,idx2,e) {
      let target = this.accessList[idx1].rowLists
      target[idx2].access = e
      if(target[idx2].childMenu.length) {
        for(let i = 0; i < target[idx2].childMenu.length; i++) {
          target[idx2].childMenu[i].access = e
        }
      }
      // let tickNum = 0
      // for(let i = 0; i < target.length; i++) {
      //   if(target[i].access == 1) tickNum++
      // }
      // if(tickNum == target.length) {
      //   this.accessList[idx1].access = 1
      // } else {
      //   this.accessList[idx1].access = 0
      // }
      this.checkAll(idx1)
    },
    changeColListsChild(idx1,idx2,idx3,e) {
      let target = this.accessList[idx1].rowLists[idx2].childMenu
      target[idx3].access = e
      let tickNum = 0
      for(let i = 0; i < target.length; i++) {
        if(target[i].access == 1) tickNum++
      }

      // 三级全选把二级勾选
      // if(tickNum == target.length) {
      //   this.accessList[idx1].rowLists[idx2].access = 1
      // } else {
      //   this.accessList[idx1].rowLists[idx2].access = 0
      // }

      // 三级任意勾选激活二级
      if(tickNum) {
        this.accessList[idx1].rowLists[idx2].access = 1
      } else {
        this.accessList[idx1].rowLists[idx2].access = 0
      }
 
      this.checkAll(idx1)
    },
    checkAll(idx1) {
      var tickNum = 0, parentTarget = this.accessList[idx1].rowLists
      for(let j = 0; j < parentTarget.length; j++){//全选checkbox状态
        if(parentTarget[j].access == 1) tickNum++
      }

      // 二级全选把一级勾选
      // if(tickNum == parentTarget.length) {//二级全勾选
      //   this.accessList[idx1].access = 1
      // } else {
      //   this.accessList[idx1].access = 0
      // }

      // 二级任意勾选激活一级
      if(tickNum) {
        this.accessList[idx1].access = 1
      } else {
        this.accessList[idx1].access = 0
      }
    },
    back() {
      this.$router.back()
    },
    getDivisionAccessMapa(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Division/GetDivisionAccessMap",
        params: params,
        success(res) {
          self.accessList = res;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    updateDivisionAccess() {
      let data = {
        divisionID: this.divisionID,
        accessMap: this.dealAccessMap()
      }
      let self = this;
      // self.loading = true;
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Division/UpdateDivisionAccess",
        data: data,
        success(res) {
          self.$message.success('操作成功！')
          self.$router.back()
          // self.loading = false;
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    dealAccessMap() {
      let res = []
      let accessList = this.accessList
      for(let i = 0; i < accessList.length; i++) {
        res.push({
          menuID: accessList[i].menuID,
          access: accessList[i].access
        })
        if(accessList[i].rowLists.length) {
          let rowLists = accessList[i].rowLists
          for(let j = 0; j < rowLists.length; j++) {
            res.push({
              menuID: rowLists[j].menuID,
              access: rowLists[j].access
            })
            if(rowLists[j].childMenu.length) {
              let childMenu = rowLists[j].childMenu
              for(let k = 0; k < childMenu.length; k++)
              res.push({
                menuID: childMenu[k].menuID,
                access: childMenu[k].access
              })
            }
          }
        }
      }
      return res
    }
  },
  created() {
    this.divisionID = this.$route.query.divisionID;
    this.divisionName = decodeURI(this.$route.query.divisionName);
    this.getDivisionAccessMapa({
      divisionId: this.divisionID
    });
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.authority-setting {
    .btn-wrapper {
      position: fixed;
      top: 80px;
      right: 60px;
    }
  .content {
    padding: 20px 50px 0;
    h1 {
      padding-left: 20px;
      line-height: 50px;
      background: #efefef;
    }
    .multipleBox {
      margin-top: 40px;
    }
    .second {
      margin-left: 70px;
    }
    .third {
      margin-left: 70px;
    }
  }
}
</style>